/* eslint-disable consistent-return */
/* eslint-disable camelcase */

import { updatePackage } from '@lib/axios/package'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useUpdate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Mengubah Paket')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    (data) => updatePackage(data)
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
      queryClient.invalidateQueries('saas-package')
    },
  })
}

export default useUpdate
